import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import ThumbDownAltOutlinedIcon from "@mui/icons-material/ThumbDownAltOutlined";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import type { MouseEvent as ReactMouseEvent } from "react";
import type { MatchReaction } from "../../../services/matchesApi";
import { hasLikeReaction, hasLoveReaction } from "../utils";

export const ReactionButtons = ({
  current,
  onChange,
  disabled,
  isMutualLove,
}: {
  current: MatchReaction;
  onChange: (next: MatchReaction) => void;
  disabled?: boolean;
  isMutualLove?: boolean;
}) => {
  const handleClick = (
    event: ReactMouseEvent<HTMLButtonElement>,
    next: MatchReaction
  ) => {
    event.stopPropagation();
    if (disabled) return;
    onChange(next);
  };
  const loveActive = hasLoveReaction(current);
  const likeActive = hasLikeReaction(current);
  const isMutualLoveActive = loveActive && Boolean(isMutualLove);

  return (
    <div className="matches-reaction-buttons" aria-label="Reaction controls">
      <button
        type="button"
        className={`reaction-button ${loveActive ? "is-active" : ""} ${
          isMutualLoveActive ? "is-mutual-love" : ""
        }`}
        aria-pressed={loveActive}
        aria-label="Love"
        onClick={(event) => handleClick(event, "love")}
        disabled={disabled}
      >
        {loveActive ? <FavoriteIcon /> : <FavoriteBorderIcon />}
      </button>
      <button
        type="button"
        className={`reaction-button ${likeActive ? "is-active" : ""}`}
        aria-pressed={likeActive}
        aria-label="Like"
        onClick={(event) => handleClick(event, "like")}
        disabled={disabled}
      >
        {likeActive ? <ThumbUpAltIcon /> : <ThumbUpAltOutlinedIcon />}
      </button>
      <button
        type="button"
        className={`reaction-button ${current === "not_for_me" ? "is-active" : ""}`}
        aria-pressed={current === "not_for_me"}
        aria-label="Not for me"
        onClick={(event) => handleClick(event, "not_for_me")}
        disabled={disabled}
      >
        {current === "not_for_me" ? (
          <ThumbDownAltIcon />
        ) : (
          <ThumbDownAltOutlinedIcon />
        )}
      </button>
    </div>
  );
};
